import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=dbdb8fba&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"
import style0 from "./Media.vue?vue&type=style&index=0&id=dbdb8fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdb8fba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Vimeo: require('/vercel/path0/components/Vimeo.vue').default,VideoPlayer: require('/vercel/path0/components/VideoPlayer.vue').default,StrapiImage: require('/vercel/path0/components/StrapiImage.vue').default})
